'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TextLine.scss');

var TextLine = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(TextLine, _PureComponent);

  function TextLine() {
    (0, _classCallCheck3.default)(this, TextLine);
    return (0, _possibleConstructorReturn3.default)(this, (TextLine.__proto__ || (0, _getPrototypeOf2.default)(TextLine)).apply(this, arguments));
  }

  (0, _createClass3.default)(TextLine, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          title = _props.title,
          overflow = _props.overflow,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'title', 'overflow']);

      var displayedTitle = title || (typeof children === 'string' ? children : '');

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: (0, _bind2.default)(styles.textLine, (0, _defineProperty3.default)({}, styles.overflowHidden, !overflow), className),
          title: displayedTitle
        }, rest),
        children
      );
    }
  }]);
  return TextLine;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  className: _propTypes2.default.string,
  overflow: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _class.defaultProps = {
  overflow: false
}, _temp);
exports.default = TextLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TextLine/TextLine.js
// module id = 855
// module chunks = 1